import type { BattleEvent, HeroTemplate, OwnedHero } from './types.js'

export const FACTION_NAMES = { ember: 'Пламя', tide: 'Прилив', grove: 'Роща' } as const
export const RARITY_NAMES = { common: 'Обычный', rare: 'Редкий', epic: 'Эпический' } as const

export function catalogMap(catalog: readonly HeroTemplate[]): Map<string, HeroTemplate> {
  return new Map(catalog.map(hero => [hero.id, hero]))
}

// В истории лежит сторона-победитель как она названа в движке. Человеку нужно
// знать не «blue», а свой исход: игрок всегда играет за синих в «Прорыве»
// и за player в «Призыве».
export function battleOutcome(winner: string): string {
  if (winner === 'blue' || winner === 'player') return 'Победа'
  if (winner === 'draw') return 'Ничья'
  return 'Поражение'
}

export function heroLabel(hero: OwnedHero, catalog: Map<string, HeroTemplate>): string {
  const template = catalog.get(hero.templateId)
  return `${template?.name ?? hero.templateId} · ур. ${hero.level}`
}

export function eventText(event: BattleEvent): string {
  switch (event.type) {
    case 'battle_started': return event.mode === 'raid' ? 'Бой начался' : 'Бой начался'
    case 'unit_spawned': return event.role === 'creep'
      ? `Волна ${event.wave}: вышел ${event.name}`
      : `${event.name} занял позицию`
    case 'wave_released': return `Автоматически вышла волна ${event.wave}`
    case 'unit_moved': return 'Отряд продвинулся по линии'
    case 'attack': return `${event.abilityId ? 'Умение' : 'Атака'}: ${event.damage} урона${event.critical ? ' · крит!' : ''}`
    case 'unit_died': return event.role === 'creep' ? 'Крип погиб' : 'Герой выбыл'
    case 'experience_granted': return event.reason === 'enemy_creep_killed'
      ? `${event.side === 'blue' ? 'Синяя' : 'Красная'} команда получила ${event.amount} опыта за чужого крипа`
      : `Отряд получил ${event.amount} опыта за победу`
    case 'base_damaged': return `База потеряла ${event.damage} здоровья`
    case 'battle_ended': return event.winner === 'draw'
      ? 'Бой завершён вничью'
      : `Победитель: ${event.winner}`
  }
}
